// Author thq
// Date 2021-06-09 10:13:08

class EmAcctLevel {
constructor({
        id = null,
        code = '',
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new EmAcctLevel();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.accident.emAcctLevel.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.accident.emAcctLevel.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.accident.emAcctLevel.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.accident.emAcctLevel.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    codeFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.em.accident.emAcctLevel.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.accident.emAcctLevel.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.accident.emAcctLevel.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.accident.emAcctLevel.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.accident.emAcctLevel.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmAcctLevel, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
